import GenericFetch from 'framework/genericfetch'

/**
 * Mapping Error Table from the Backend
 */
const ERROR_BACKEND_MAPPING = {}

/**
 * Fetching API class.
 */
export default class Fetch extends GenericFetch {
    constructor(config, otherApis = {}) {
        super(config, 'adobe', ERROR_BACKEND_MAPPING)
        this.registerErrors(ERROR_BACKEND_MAPPING)
    }
}
